export const tagPropsMap = {
    REMOVAL_IN_PROGRESS: { label: 'Removal in progress', appearance: 'alert' },
    SYNCING_YOUR_DOMAIN: { label: 'Syncing your domain', appearance: 'neutral' },
    CONNECTED: { label: 'Connected', appearance: 'success' },
    PARTIALLY_CONNECTED: { label: 'Partially Connected', appearance: 'success' },
    NOT_CONNECTED: { label: 'Not connected', appearance: 'caution' },
};
